/* 
  VIDEO PLAYS IN VIEW
  Play pause videos when they come in to the viewport
*/
import $ from 'jquery';

const playPauseVideosInView = () => { 
  const cocktailCard = $('.js-cocktail-card');

  cocktailCard
    .on('mouseenter', function () {
      var topImage = $(this).find('.js-cocktail-video-image')
      var video = $(this).find('.js-cocktail-video-hover');

      setTimeout(function () {
        topImage.addClass('hovered');
      }, 600);

      if(video.length) {
        setTimeout(function(){
          video[0].play();
        }, 600)
      }
    })
    .on('mouseleave', function () {
      var topImage = $(this).find('.js-cocktail-video-image');
      var video = $(this).find('.js-cocktail-video-hover');
      setTimeout(function(){
        topImage.removeClass('hovered');
      }, 600)
      if (video.length) {
        video[0].pause()
        video[0].currentTime = 0;        
      }      
    });    

  const videos = document.querySelectorAll('.js-video-plays-in-view');
  
  videos.forEach((video) => {
    // We can only control playback without interaction if video is muted
    video.muted = true;
    // Play is a promise so we need to check we have it
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.then((_) => {
        let observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio <= 0.1 && !video.paused) {
                video.pause();
                // If the video has the "delay" class, reset it to the start
                if (video.classList.contains('delay')) {
                  video.currentTime = 0;
                }
              } else if (video.paused) {
                // Set the timeout delay based on the presence of the "delay" class
                const delayTime = video.classList.contains('delay')
                  ? 4000
                  : 500;
                setTimeout(function () {
                  video.play();
                }, delayTime);
              }
            });
          },
          { threshold: 0.1 },
        );

        observer.observe(video);
      });
    }
  });

};
export default playPauseVideosInView;
/*  END VIDEO PLAYS IN VIEW */
